import React, { useState } from "react";
import { useGetPurchaseOrderNumbers } from "./graphql/get-po-numbers";
import { useGetVenues } from "./graphql/get-venues";
import { Container, SearchWrapper, Text } from "./po-numbers.styles";
import { RotaSearchInput, useToast } from "@teamrota/rota-design";
import Table from "./components/po-table";
import POFilter from "./components/po-filter";
import { usePOFilter } from "./hooks/use-po-filter";
import { useBulkMutatePurchaseOrderNumbers } from "./graphql/bulk-mutate-po-numbers";

const UserPONumbers = ({ targetAccountId, roleRates }) => {
  const { showToast } = useToast();
  const { bulkMutate } = useBulkMutatePurchaseOrderNumbers();
  const { venues, loading: venuesLoading } = useGetVenues(targetAccountId);
  const [searchTerm, setSearchTerm] = useState("");

  // Use the filter hook
  const {
    filters,
    openDropdowns,
    isAnyFilterSelected,
    dropdownOptions,
    selectedVenuesIds,
    selectedRoleRateIds,
    selectedSubvenuesIds,
    toggleDropdown,
    handleSearch,
    handleSelect,
    handleClear
  } = usePOFilter(venues, roleRates);

  // Data fetching with loading/error states
  const {
    purchaseOrderNumbers,
    loading: poLoading
  } = useGetPurchaseOrderNumbers(targetAccountId, searchTerm, {
    venueIds: selectedVenuesIds,
    subvenueIds: selectedSubvenuesIds,
    roleRateIds: selectedRoleRateIds
  });

  const isLoading = poLoading || venuesLoading;

  const handleSaveChanges = async changes => {
    try {
      const result = await bulkMutate({
        added: changes.added || [],
        updated: changes.updated || [],
        deleted: changes.deleted || []
      });

      if (result.success) {
        showToast("Changes saved successfully.", { severity: "success" });
      } else {
        showToast("Changes could not be saved.", { severity: "error" });
      }
    } catch (error) {
      showToast("Changes could not be saved.", { severity: "error" });
    }
  };

  return (
    <Container>
      <Text marginBottom>
        Assign PO numbers that will automatically apply to a venue or subvenue's
        timesheets.
      </Text>
      <SearchWrapper>
        <POFilter
          filters={filters}
          openDropdowns={openDropdowns}
          toggleDropdown={toggleDropdown}
          handleSearch={handleSearch}
          handleSelect={handleSelect}
          handleClear={handleClear}
          dropdownOptions={dropdownOptions}
          isAnyFilterSelected={isAnyFilterSelected}
        />
        <RotaSearchInput
          onChange={value => setSearchTerm(value)}
          styles={{
            width: "100%"
          }}
          placeholder="Search venue, subvenue or role by name"
          value={searchTerm}
        />
      </SearchWrapper>

      <Table
        initialPONumbers={purchaseOrderNumbers}
        venues={venues}
        roleRates={roleRates}
        searchTerm={searchTerm}
        targetAccountId={targetAccountId}
        onSaveChanges={handleSaveChanges}
        selectedVenuesIds={selectedVenuesIds}
        selectedSubvenuesIds={selectedSubvenuesIds}
        selectedRoleRateIds={selectedRoleRateIds}
        isLoading={isLoading}
      />
    </Container>
  );
};

export default UserPONumbers;
